import { useQuery } from '@tanstack/react-query'
import { normalizeUploadedFiles } from '../model/imports.normalize'
import { UploadedFileApiDto } from '../model/imports.api.dto'
import { getProcessedFiles } from '@/lib/api/company/fileProcessing/processedFilesById/getProcessedFiles'
import { ProcessedFilesDetails } from '@/lib/api/company/fileProcessing/processedFilesById'
import mock from '../mock.json'
import { MOCK_UPLOAD } from '../pages/home/config'

type ProcessedFilesResponse = { taskId: string; files: UploadedFileApiDto[] }

type Params = {
  companyId: string
  fileId: string
  disabled?: boolean
  /** Odczyt po zapisie - osobny wpis w cache, zawsze świeży. */
  afterSave?: boolean
}

export function useProcessedFilesReadModel({ disabled = false, companyId, fileId, afterSave = false }: Params) {
  return useQuery({
    queryKey: ['imports', 'processedFiles', companyId, fileId, afterSave],
    queryFn: async () => {
      if (MOCK_UPLOAD) {
        return { data: mock as unknown as ProcessedFilesDetails }
      }

      return await getProcessedFiles({
        companyId,
        fileId: fileId.toString(),
      })
    },
    select: (d) => {
      return normalizeUploadedFiles(d.data)
    },
    enabled: !disabled && Boolean(companyId && fileId),
    staleTime: afterSave ? 0 : 30_000,
    gcTime: afterSave ? 0 : undefined,
  })
}
